import apiService from './apiService';

export const chatService = {
  // ==================== Chats CRUD ====================
  
  async getChats(params?: { page?: number; limit?: number }): Promise<any> {
    return apiService.get('/chat', { params });
  },

  async getChat(id: string): Promise<any> {
    return apiService.get(`/chat/${id}`);
  },

  async createChat(data: { name: string; type: 'individual' | 'group'; participantIds: string[] }): Promise<any> {
    return apiService.post('/chat', data);
  },

  async createIndividualChat(data: { recipientId: string }): Promise<any> {
    return apiService.post('/chat/individual', data);
  },

  async updateChat(id: string, data: { name?: string; avatar?: string }): Promise<any> {
    return apiService.put(`/chat/${id}`, data);
  },

  async leaveChat(id: string): Promise<void> {
    return apiService.delete(`/chat/${id}`);
  },

  async getUnreadCounts(): Promise<any> {
    return apiService.get('/chat/unread');
  },

  // ==================== Messages ====================

  async getMessages(chatId: string, params?: { page?: number; limit?: number; before?: string }): Promise<any> {
    return apiService.get(`/chat/${chatId}/messages`, { params });
  },

  async getMessage(chatId: string, messageId: string): Promise<any> {
    return apiService.get(`/chat/${chatId}/messages/${messageId}`);
  },

  async sendMessage(chatId: string, data: { content: string; attachments?: string[] }): Promise<any> {
    return apiService.post(`/chat/${chatId}/messages`, data);
  },

  async updateMessage(chatId: string, messageId: string, data: { content: string }): Promise<any> {
    return apiService.put(`/chat/${chatId}/messages/${messageId}`, data);
  },

  async deleteMessage(chatId: string, messageId: string): Promise<void> {
    return apiService.delete(`/chat/${chatId}/messages/${messageId}`);
  },

  // ==================== Read Status ====================

  async markChatRead(chatId: string): Promise<void> {
    return apiService.post(`/chat/${chatId}/read`);
  },

  // ==================== Participants ====================

  async getParticipants(chatId: string): Promise<any> {
    return apiService.get(`/chat/${chatId}/participants`);
  },

  async addParticipant(chatId: string, data: { userId: string; role?: 'member' | 'admin' }): Promise<any> {
    return apiService.post(`/chat/${chatId}/participants`, data);
  },

  async updateParticipant(chatId: string, userId: string, data: { role: 'member' | 'admin' }): Promise<any> {
    return apiService.put(`/chat/${chatId}/participants/${userId}`, data);
  },

  async removeParticipant(chatId: string, userId: string): Promise<void> {
    return apiService.delete(`/chat/${chatId}/participants/${userId}`);
  },
};
